import * as ROUTES from './routes';
const authRoutes = [
    ROUTES.CMS_SUBS.root.path,
    ROUTES.CMS_SUBS.root.subs.login.path,
];

export default authRoutes;